import React from "react";
import footer from '../assets/footer-image.png';

const Footer = () => (
  <div className="footer">
      <img className= 'footer-img' src={footer} alt="Footer" />
  </div>
);

export default Footer;